const Classroom = require('./Classroom');
const Program = require('./Program');

const { formatAgeAsOfNumberToDateObj } = require('./utils');

class AgeGroup {
  constructor() {
    this.init();
  }

  init() {
    this.age_group_id = undefined;
    this.list_id = undefined;
    this.center_id = undefined;
    this.name = undefined;
    this.center_name = undefined;
    this.provider_name = undefined;
    this.min_age = undefined;
    this.max_age = undefined;
    this.min_age_weeks = undefined;
    this.age_as_of = undefined;
    this.classrooms = undefined;
    this.programs = undefined;
  }

  copy() {
    const cp = new AgeGroup();

    cp.age_group_id = this.age_group_id;
    cp.list_id = this.list_id;
    cp.center_id = this.center_id;
    cp.name = this.name;
    cp.center_name = this.center_name;
    cp.provider_name = this.provider_name;
    cp.min_age = this.min_age;
    cp.max_age = this.max_age;
    cp.min_age_weeks = this.min_age_weeks;
    cp.age_as_of = this.age_as_of;
    if (this.classrooms) {
      cp.classrooms = [];
      this.classrooms.forEach((c) => {
        cp.classrooms.push(c.copy());
      });
    }
    if (this.programs) {
      cp.programs = [];
      this.programs.forEach((p) => {
        cp.programs.push(p.copy());
      });
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      // Should we do validation on days, times, and question list?
      this.age_group_id = obj.age_group_id ? obj.age_group_id.toString() : undefined;
      this.list_id = obj.list_id ? obj.list_id.toString() : undefined;
      this.center_id = obj.center_id ? obj.center_id.toString() : undefined;
      this.name = obj.name ? obj.name : undefined;
      this.center_name = obj.center_name ? obj.center_name : undefined;
      this.provider_name = obj.provider_name ? obj.provider_name : undefined;
      this.min_age = obj.min_age ? obj.min_age : undefined;
      this.max_age = obj.max_age ? obj.max_age : undefined;
      this.min_age_weeks = (obj.min_age_weeks === undefined) || (obj.min_age_weeks === null)
        ? undefined : obj.min_age_weeks;
      this.age_as_of = obj.age_as_of ? obj.age_as_of : undefined;

      if (obj.classrooms) {
        this.classrooms = [];
        obj.classrooms.forEach((c) => {
          const classroom = new Classroom();
          classroom.buildFromJSON(c);
          this.classrooms.push(classroom);
        });
      }
      if (obj.programs) {
        this.programs = [];
        obj.programs.forEach((p) => {
          const program = new Program();
          program.buildFromJSON(p);
          this.programs.push(program);
        });
      }
    }
  }

  toString() {
    let result = this.name ? this.name : '';
    return result;
  }

  getId() {
    return this.age_group_id;
  }

  setId(age_group_id) {
    this.age_group_id = age_group_id ? age_group_id.toString() : undefined;
  }
  
  getListId() {
    return this.list_id;
  }

  setListId(list_id) {
    this.list_id = list_id ? list_id.toString() : undefined;
  }

  getCenterId() {
    return this.center_id;
  }

  setCenterId(center_id) {
    this.center_id = center_id ? center_id.toString() : undefined;
  }

  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getCenterName() {
    return this.center_name;
  }

  getProviderName() {
    return this.provider_name;
  }

  getMinAge() {
    return this.min_age;
  }

  setMinAge(min_age) {
    this.min_age = min_age;
  }

  getMaxAge() {
    return this.max_age;
  }

  setMaxAge(max_age) {
    this.max_age = max_age;
  }

  getMinAgeWeeks() {
    return this.min_age_weeks;
  }

  setMinAgeWeeks(min_age_weeks) {
    this.min_age_weeks = min_age_weeks;
  }

  getAgeAsOf() {
    if (!this.age_as_of) {
      return undefined;
    }

    return formatAgeAsOfNumberToDateObj(this.age_as_of);
  }

  getAgeAsOfFixed() {
    if (!this.age_as_of) {
      return undefined;
    }

    return (this.age_as_of > 10000);
  }
  
  setAgeAsOf(age_as_of, includeYear = false) {
    if (!age_as_of) {
      this.age_as_of = undefined;
    } else {
      // Pull the month and day off and set those
      // Special case - we don't allow setting February 29 (make it Feb 28)
      const date = new Date(age_as_of);
      const month = date.getUTCMonth();
      const year = includeYear ? date.getUTCFullYear() : 0;
      let day = date.getUTCDate();
      if ((month === 1) && (day > 28) && (year === 0)) {
        day = 28;
      }

      this.age_as_of = (year * 10000) + (month + 1) * 100 + day;
    }
  }

  getClassrooms() {
    return this.classrooms;
  }

  setClassrooms(classrooms) {
    this.classrooms = undefined;
    if (classrooms) {
      this.classrooms = [];
      classrooms.forEach((c) => {
        this.classrooms.push(c.copy());
      });
    }
  }

  getPrograms() {
    return this.programs;
  }

  setPrograms(programs) {
    this.programs = undefined;
    if (programs) {
      this.programs = [];
      programs.forEach((p) => {
        this.programs.push(p.copy());
      });
    }
  }
}

module.exports = AgeGroup;
